import React, { useState } from "react";
import { withTranslation } from "../../../i18n";
import moment from "moment";
import { useToasts } from "react-toast-notifications";
import UserService from "@/services/domain/UserService";
import Input from "@/shared/form/input/Input";
import InputDate from "@/shared/form/inputDate/InputDate";
import Button from "@/shared/button/simpleButton/Button";
import CustomForm from "@/shared/form/custom-form/CustomForm";
import InputError from "@/shared/common/input-error/InputError";
import { userSchema } from "@unty-gl/validation";
import css from "./FooterNewsletter.module.scss";
import SocialMediaLinks from "../SocialMediaLinks";

const namespacesRequired = ["footer"];

const FooterNewsletter = ({ t }) => {
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  const logoImage = "/static/images/logos/logo.png";

  const getInitialValues = () => {
    return {
      wedding_date: "",
      email: "",
    };
  };

  const onSubmit = (values) => {
    const valueToUpdate = {
      // `Date(x)` ignores its argument and returns the current date, so every
      // signup used to be stored with the day it was made. GL-5227
      wedding_date: values.wedding_date,
      email: values.email,
      opt_in_2: true,
      opt_in_1: true,
    };

    setLoading(true);

    UserService.updateOptins(valueToUpdate)
      .then((user) => {

        addToast(t("footer:newsletter-confirm-message"), {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .catch((error) => {
        if (
          error.data &&
          error.data.errors &&
          error.data.errors[0] &&
          error.data.errors[0].code === "E_INVALID_EMAIL"
        ) {
          addToast(t("footer:newsletter-error-message"), {
            appearance: "error",
            autoDismiss: true,
          });
        } else {
          addToast(t("footer:newsletter-error-message-default"), {
            appearance: "error",
            autoDismiss: true,
          });
        }
      })
      .finally(() => setLoading(false));
  };

  const renderForm = ({
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
  }) => {
    return (
      <form onSubmit={handleSubmit} noValidate>
        <div className={css.formRow}>
          <Input
            customClass={css.emailField}
            inputId="email"
            inputLabel={null}
            inputName="email"
            inputType="email"
            inputPlaceholder={t("footer:newsletter-placeholder")}
            errors={errors}
            touched={touched}
            value={values["email"]}
            onChange={handleChange}
            hideErrors={true}
          />

          <InputDate
            customClass={css.dateField}
            customDatepicker={css.datePicker}
            inputName="wedding_date"
            inputId="wedding_date"
            errors={errors}
            value={values["wedding_date"]}
            inputMinDate={moment()}
            inputPlaceholder={t("footer:newsletter-date-placeholder")}
            hideErrors={true}
            numericMask
          />

          <Button
            customClass={css.submitButton}
            loading={loading}
            type="submit"
            disabled={!values.email}
          >
            <span>{t("footer:validate")}</span>
          </Button>
        </div>

        {/* Under the row, not inside it: `.formRow` is a 34px bar and an error
            rendered inside a flex item would overflow it. GL-5226 */}
        <div className={css.formErrors}>
          <InputError name="email" />
          <InputError name="wedding_date" />
        </div>
      </form>
    );
  };

  return (
    <div className={css.newsletter}>
      <div className={css.brand}>
        <img className={css.logo} src={logoImage} alt="Mille et une listes" />
        <p className={css.description}>{t("footer:description")}</p>
      </div>
      <div className={css.adviceTitle}>
        <span className={css.adviceTitleMain}>
          {t("footer:advice-title-main")}
        </span>
        <span className={css.adviceTitleAccent}>
          {t("footer:advice-title-accent")}
        </span>
      </div>
      <CustomForm
        initialValues={getInitialValues()}
        schema={userSchema.susbscribe_newsletter}
        onSubmit={onSubmit}
        render={renderForm}
        wrapperClassName={css.formWrapper}
      />
      <div className={`${css.followSection} ${css.followDesktop}`}>
        <p className={css.followTitle}>{t("footer:follow-us")}</p>
        <SocialMediaLinks />
      </div>
    </div>
  );
};

export default withTranslation(namespacesRequired)(FooterNewsletter);
